import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import type { DragAndDropKeyframesAppState } from './types';

const initialState: DragAndDropKeyframesAppState = {
  waiting: [],
  success: {},
  originalSource: {},
};

type SuccessPayload = { id: string; items: SearchItemEntity[] };
type OriginalSourcePayload = {
  id: string;
  keyframes: FilesKeyframeSchemaWithIdNullable[];
};

export const dragAndDropKeyframesSlice = createSlice({
  name: 'drag_and_drop_keyframes',
  initialState,
  reducers: {
    dragAndDropKeyframesWaiting: (state, action: PayloadAction<string>) => {
      state.waiting.push(action.payload);
    },
    dragAndDropKeyframesOriginalSource: (
      state,
      action: PayloadAction<OriginalSourcePayload>,
    ) => {
      const existing = state.originalSource[action.payload.id] || [];
      state.originalSource[action.payload.id] = [
        ...action.payload.keyframes,
        ...existing,
      ];
    },
    dragAndDropKeyframesSuccess: (
      state,
      action: PayloadAction<SuccessPayload>,
    ) => {
      const existing = state.success[action.payload.id] || [];
      state.success[action.payload.id] = [...action.payload.items, ...existing];
      state.waiting = state.waiting.filter((id) => id !== action.payload.id);
    },
  },
});

export const {
  dragAndDropKeyframesWaiting,
  dragAndDropKeyframesSuccess,
  dragAndDropKeyframesOriginalSource,
} = dragAndDropKeyframesSlice.actions;

export const dragAndDropKeyframesReducer = dragAndDropKeyframesSlice.reducer;
